module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "content-wrapper",
    staticStyle: {
      "border": "1px solid black",
      "width": "100%",
      "margin": "0",
      "padding": "40px 10px 20px 10px",
      "font-family": "Arial"
    },
    attrs: {
      "id": "agreementform",
      "contenteditable": "true"
    }
  }, [_c('img', {
    staticStyle: {
      "margin-top": "30px",
      "height": "55px",
      "width": "25%"
    },
    attrs: {
      "src": _vm.LogoImg,
      "alt": "automatad-logo"
    }
  }), _vm._v(" "), _c('center', {
    staticClass: "heading",
    staticStyle: {
      "margin-bottom": "20px",
      "font-size": "18px"
    }
  }, [_c('b', [_vm._v("Service Terms and Conditions(“Terms”)")])]), _vm._v(" "), _c('p', [_c('b', [_vm._v("THIS AGREEMENT")]), _vm._v(" is made between "), _c('b', [_vm._v("Automatad, Inc. (“Automatad”)")]), _vm._v(" and "), _c('span', {
    staticStyle: {
      "border-bottom": "1px solid black",
      "min-width": "110px",
      "display": "inline-block"
    }
  }, [_c('span', [_vm._v(_vm._s(_vm.LegalPublisherName))])]), _vm._v(" "), _c('b', [_vm._v("(\"Publisher\") NOW THEREFORE THIS AGREEMENT WITNESSES THAT")]), _vm._v(" in consideration of good and valuable consideration,\n    the receipt and sufficiency of which are hereby acknowledged, the parties hereby covenant and agree as follows:")]), _vm._v(" "), _c('b', [_vm._v("1.    DEFINITIONS -")]), _vm._v(" "), _vm._m(0), _vm._v(" "), _c('b', [_vm._v("2.    TERM -")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "margin-left": "25px"
    }
  }, [_vm._v(" The term shall commence on the Effective Date. The term shall continue for a period of one (1) year and shall automatically renew at the end\n        of the one (1) year (collectively, the “Term”), unless otherwise earlier terminated by either party in accordance with this Agreement.")]), _vm._v(" "), _c('b', [_vm._v("3.    FEES AND REVENUES –")]), _c('br'), _vm._v(" "), _c('ol', {
    staticClass: "list-items",
    staticStyle: {
      "margin-left": "40px"
    },
    attrs: {
      "type": "a"
    }
  }, [_c('li', {
    staticStyle: {
      "padding-left": "10px"
    },
    attrs: {
      "contenteditable": "false"
    }
  }, [_vm._v(" The Revenue Share Fee shall be "), _c('b', [_vm._v(_vm._s(_vm.revenuShare + '%'))]), _vm._v(" of Gross Revenue.")]), _vm._v(" "), _c('li', {
    staticStyle: {
      "padding-left": "10px"
    }
  }, [_vm._v(" Net Revenues shall be sent to Publisher by Automatad within "), _c('b', {
    attrs: {
      "contenteditable": "false"
    }
  }, [_vm._v(_vm._s(_vm.periodToSendRevPub + " days"))]), _vm._v(" from the first day of the month following the month in which the Net\n            Revenues were earned. For clarity, Net Revenues earned in "), _c('b', {
    attrs: {
      "contenteditable": "false"
    }
  }, [_vm._v(_vm._s(_vm.example))]), _vm._v(".")]), _vm._v(" "), _c('li', {
    staticStyle: {
      "padding-left": "10px"
    }
  }, [_vm._v(" Automatad will not pay out any Running Balances less than Minimum Running Balance. If monthly Net Revenue is lower than the Minimum\n            Running Balance, it will be paid out in the first pay period where the Running Balance exceeds the Minimum Running Balance. If Net\n            Revenue in any month is less than $5.00 USD, the Net Revenue in that month will be $0 for all purposes.")]), _vm._v(" "), _c('li', {
    staticStyle: {
      "padding-left": "10px"
    }
  }, [_vm._v(" The Fee shall be calculated based on Automatad’s dashboard. In the event of a discrepancy of greater than 10% between Automatad’s records and Publisher’s records the parties shall review the data in good faith to resolve the discrepancy.")]), _vm._v(" "), _c('li', {
    staticStyle: {
      "padding-left": "10px"
    }
  }, [_vm._v(" Publisher shall be responsible for payment of any taxes on Gross Revenues with the exception of corporate income taxes incurred by\n            Automatad on The Fee.")]), _vm._v(" "), _c('li', {
    staticStyle: {
      "padding-left": "10px"
    }
  }, [_vm._v(" Net Revenues generated from prohibited content and/or fraudulent activities or in the event Revenues are uncollectible from Advertising Partners will not be paid by Automatad to Publisher. In the event these amounts have already been paid by Automatad to Publisher, Automatad shall have the right to withhold the balance receivable from future Net Revenues or to require immediate payment from Publisher to Automatad.")]), _vm._v(" "), _c('li', {
    staticStyle: {
      "padding-left": "10px"
    }
  }, [_vm._v(" In the event Net Revenues are less than zero for a month, the net amount owing to Automatad shall be paid by the Publisher to Automatad within 60 days from the first day of the month following the month in which the Revenues were earned. Should Publisher owe a balance to Automatad, Automatad shall issue an invoice to Publisher at least 15 days prior to the due date.")])]), _vm._v(" "), _c('b', [_vm._v("4.    TERMINATION OF AGREEMENT –")]), _vm._v(" "), _c('ol', {
    staticClass: "list-items",
    staticStyle: {
      "margin-left": "40px"
    },
    attrs: {
      "type": "a"
    }
  }, [_vm._m(1), _vm._v(" "), _c('li', {
    staticStyle: {
      "padding-left": "10px"
    }
  }, [_vm._v(" The Term may be terminated by Publisher on "), _c('b', {
    attrs: {
      "contenteditable": "false"
    }
  }, [_vm._v(_vm._s(_vm.terminationDuration + " hours'"))]), _vm._v(" notice to Automatad.")]), _vm._v(" "), _c('li', {
    staticStyle: {
      "padding-left": "10px"
    }
  }, [_vm._v(" The Term may be terminated by Automatad immediately if Automatad reasonably believes there is any prohibited content or fraudulent activities.")]), _vm._v(" "), _c('li', {
    staticStyle: {
      "padding-left": "10px"
    }
  }, [_vm._v(" On the effective date of termination, all licenses granted hereunder shall terminate, all confidential information shall be returned to the respective party, the Automatad ad tags shall be turned off and Publisher shall cease use of any Automatad ad tags, code or other intellectual property.")]), _vm._v(" "), _c('li', {
    staticStyle: {
      "padding-left": "10px"
    }
  }, [_vm._v(" Unless otherwise stated herein, a party shall pay all Net Revenues, up to the effective date of termination in accordance with Section 3.")])]), _vm._v(" "), _c('b', [_vm._v("5.    PUBLISHER MEDIA - ")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "margin-left": "25px"
    }
  }, [_vm._v(" Publisher must obtain Automatad’s prior written approval over all Publisher Media on which Publisher wishes to make ad inventory available through Automatad platform. Automatad may reject any Publisher Media for any reason in its sole discretion, and may also withdraw approval following acceptance (and cease delivery of ads to such Publisher Media) if Automatad reasonably determines any Publisher Media: (i) is no longer complying with the terms of this Agreement, (ii) has substantially changed since approval or no longer meets Automatad’s approval standards, (iii) contains prohibited content or is associated with a fraudulent activity, or (iv) is otherwise likely to cause damage or injury to the Automatad platform or Automatad’s reputation. By submitting any type of application for approval as a Publisher Media, Publisher represents and warrants to Automatad that such application: (i) provides the user with clear and conspicuous notice about all material functionality, (ii) obtains informed consent from the user prior to download, (iii) provides an easy-to-use uninstall to the user, and (iv) allows the user to maintain control over such user’s computing environment.")]), _vm._v(" "), _c('b', [_vm._v("6.    LICENSES - ")]), _c('p', {
    staticStyle: {
      "margin-left": "25px"
    }
  }, [_vm._v(" Automatad hereby grants Publisher a non-exclusive, non-transferable, revocable license to use the Automatad platform and ad tags in accordance with these Terms and in connection with the Term. The Publisher hereby grants to Automatad a non-exclusive, non-transferable, revocable license to use the Publisher’s name, logo and trademarks in accordance with these Terms and in connection with the Term. Automatad shall own and retain all right, title and interest in and to Automatad’s platform, ad tags, confidential information and other intellectual property and Publisher shall own and retain all right, title and interest to the Publisher’s name, logo, trademarks, confidential information and other intellectual property.")]), _vm._v(" "), _c('b', [_vm._v("7.    DATA USE –")]), _c('br'), _vm._v(" "), _c('p', {
    staticStyle: {
      "margin-left": "25px"
    }
  }, [_vm._v("\n        Automatad has the right to collect, use and disclose Non-Identifiable Data as follows (1) to carry out the service terms and conditions, (2) to perform analytics for general business purposes using aggregated Non-Identifiable Data from multiple sources and (3) any similar or related business purposes.")]), _vm._v(" "), _c('b', [_vm._v("8.    REPRESENTATIONS AND WARRANTIES –")]), _vm._v(" "), _vm._m(2), _vm._v(" "), _c('b', [_vm._v("9.    CONFIDENTIAL INFORMATION –")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "margin-left": "25px"
    }
  }, [_vm._v(" Confidential information means all confidential and proprietary information of a party, whether oral or in writing, which is designated or identified as confidential or that reasonably should be understood to be confidential given the nature of the information and surrounding circumstances, but shall not include information that is (1) generally known to the public without breach hereunder; (2) was known prior to disclosure hereunder without restriction on disclosure; (3) independently developed without breach hereunder; or (4) is rightfully received from a third party without any restriction on disclosure. The parties shall only use confidential information for the purposes of performing the obligations hereunder. Automatad will not sell first party data without consent.")]), _vm._v(" "), _c('b', [_vm._v("10.    INDEMNITY")]), _vm._v(" "), _vm._m(3), _vm._v(" "), _c('b', [_vm._v("11.    LIMITATION OF LIABILITY -")]), _vm._v(" "), _vm._m(4), _vm._v(" "), _c('br'), _vm._v(" "), _c('br'), _vm._v(" "), _c('b', [_vm._v("12.    MISCELLANEOUS –")]), _vm._v(" "), _vm._m(5), _vm._v("\n    Publisher Media is governed by the prior agreement or by this Agreement, this Agreement shall govern.\n    "), _vm._m(6)], 1)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('ol', {
    staticClass: "list-items",
    staticStyle: {
      "margin-left": "40px"
    },
    attrs: {
      "type": "a"
    }
  }, [_c('li', {
    staticStyle: {
      "padding-left": "10px"
    }
  }, [_vm._v(" ‘Effective Date’ means the date noted above. ")]), _vm._v(" "), _c('li', {
    staticStyle: {
      "padding-left": "10px"
    }
  }, [_vm._v(" ‘External Advertising Fees’ means any fees that Automatad must pay in order to secure advertising spend and/or host and serve video advertisements and content on behalf of Publisher.")]), _vm._v(" "), _c('li', {
    staticStyle: {
      "padding-left": "10px"
    }
  }, [_vm._v(" ‘Gross Revenue’ means earnings net of External Advertising Fees generated from traffic through the Automatad platform.")]), _vm._v(" "), _c('li', {
    staticStyle: {
      "padding-left": "10px"
    }
  }, [_vm._v(" ‘Minimum Running Balance’ means $100.")]), _vm._v(" "), _c('li', {
    staticStyle: {
      "padding-left": "10px"
    }
  }, [_vm._v(" ‘Net Revenues’ means Revenues less Fees, if applicable.")]), _vm._v(" "), _c('li', {
    staticStyle: {
      "padding-left": "10px"
    }
  }, [_vm._v(" ‘Non-Identifiable Data’ means data that does not identify an individual, corporation or other entity, for all practical purposes, when used alone or combined with other available information.")]), _vm._v(" "), _c('li', {
    staticStyle: {
      "padding-left": "10px"
    }
  }, [_vm._v(" ‘Prohibited and Fraudulent Activities’ and ‘Prohibited Content’ and ‘Fraudulent Activities’ collectively include but are not limited to activities and content that violates applicable laws or intellectual property rights or that fraudulently, deceptively or artificially inflate the number of impressions, clicks or other payable action.")]), _vm._v(" "), _c('li', {
    staticStyle: {
      "padding-left": "10px"
    }
  }, [_vm._v(" ‘Publisher Media’ means all websites and mobile applications owned or operated by Publisher.")]), _vm._v(" "), _c('li', {
    staticStyle: {
      "padding-left": "10px"
    }
  }, [_vm._v(" ‘Requests’ means the sum of raw programmatic ad requests to Automatad and direct or other ad requests to Publisher’s advertisers, as displayed in Automatad’s dashboard.")]), _vm._v(" "), _c('li', {
    staticStyle: {
      "padding-left": "10px"
    }
  }, [_vm._v(" ‘Revenues’: earnings generated through Automatad’s accounts with Advertising Partners and payable directly to Automatad")]), _vm._v(" "), _c('li', {
    staticStyle: {
      "padding-left": "10px"
    }
  }, [_vm._v(" ‘Running Balance’ means the total of all unpaid Net Revenues due to be paid.")]), _vm._v(" "), _c('li', {
    staticStyle: {
      "padding-left": "10px"
    }
  }, [_vm._v(" ‘Services’ means Automatad online advertising and real time bidding services including herein or otherwise mutually agreed to in writing between the parties.")]), _vm._v(" "), _c('li', {
    staticStyle: {
      "padding-left": "10px"
    }
  }, [_vm._v(" ‘Automatad Licensor’ means any party which licenses or provides Automatad a right to use such party’s solution or offer such solution to\n            Automatad customers and partners.")]), _vm._v(" "), _c('li', {
    staticStyle: {
      "padding-left": "10px"
    }
  }, [_vm._v(" ‘Automatad Licensor Solutions’ means services which are provided by applicable third party licensors and are obtained by Customer through Automatad.")]), _vm._v(" "), _c('li', {
    staticStyle: {
      "padding-left": "10px"
    }
  }, [_vm._v(" ‘The Fee’ and ‘Fees’ refers to all fees defined in this Agreement or amendments thereof, including the Revenue Share Fee and Ad Serving\n            Fee")]), _vm._v(" "), _c('li', {
    staticStyle: {
      "padding-left": "10px"
    }
  }, [_vm._v(" ‘Third Party Terms’ means a service or product agreement or terms and conditions offered by a third party, including Automatad Licensor")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('li', {
    staticStyle: {
      "padding-left": "10px"
    }
  }, [_vm._v(" The Term may be terminated by Automatad on "), _c('b', [_vm._v("24 hours'")]), _vm._v(" notice to Publisher.")])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', {
    staticStyle: {
      "margin-left": "25px"
    }
  }, [_vm._v("Publisher represents and warrants the following: (1) all of the Publisher’s websites, applications and other media complies with all applicable laws (the “Publisher’s Media”); (2) it shall place Automatad’s ad tags and code only on Publisher’s Media that has been approved by Automatad in writing; (3) it shall not modify or reverse engineer the Automatad platform, ad tags or other intellectual property; (4) it complies with all applicable laws, including privacy laws; (5) it shall not include any prohibited content in the Publisher’s Media; and (6) it shall not sell ad inventory on sites directed at users under the age of 13 years. Automatad represents and warrants the following: (1) it has the right to enter into the Agreement; (2) it will comply with all applicable laws and regulations relating to the Agreement; (3) it shall not modify or reverse engineer Publisher Media or other intellectual property of the Publisher; and (4) its performance of the Services will not violate or infringe on any third party’s intellectual property rights or proprietary or confidential information."), _c('br')])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('ol', {
    staticClass: "list-items",
    staticStyle: {
      "margin-left": "40px"
    },
    attrs: {
      "type": "a"
    }
  }, [_c('li', {
    staticStyle: {
      "padding-left": "10px"
    }
  }, [_vm._v(" Publisher shall indemnify, defend and hold harmless Automatad, its affiliates and their respective directors, officers, employees, agents, consultants and subcontractors (each a “Automatad Indemnitee”) from and against any and all Losses incurred by by such Automatad Indemnitee arising out of or relating to (i) allegation of facts that, if true, would constitute Publisher’s breach of any of its representations, warranties, covenants or obligations under this Agreement, (ii) negligence or willful misconduct by Publisher or any third party on behalf of Publisher in connection with this Agreement, and (iii) claims for which Publisher is at law responsible. Publisher shall also indemnify, defend and hold harmless all Automatad Licensors whose Third Party Terms apply to Publisher (“Automatad Licensor Indemnitee”) against all Losses incurred by Automatad Licensor Indemnitee in relation to breach of any of its representations, warranties, covenants or obligations under this Agreement.")]), _vm._v(" "), _c('li', {
    staticStyle: {
      "padding-left": "10px"
    }
  }, [_vm._v(" Automatad shall indemnify, defend and hold harmless Publisher and Publisher’s officers, directors, employees, agents, permitted successors and permitted assigns (each, a “Publisher Indemnitee”) from and against any and all Losses incurred by such Publisher Indemnitee arising out of or relating to any Claim by a third party (other than an Affiliate of a Publisher Indemnitee) to the extent that such Losses arise from any allegation that Publisher’s use of the Services (excluding Automatad Licensor services) in compliance with this Agreement infringes the Intellectual Property rights of a third party.")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', {
    staticStyle: {
      "margin-left": "35px"
    }
  }, [_vm._v(" NOTWITHSTANDING ANY OTHER PROVISION HEREIN OR ANY APPLICABLE STATUTORY PROVISIONS, NEITHER PARTY SHALL BE LIABLE TO THE OTHER PARTY OR ANY THIRD PARTY FOR INDIRECT, CONSEQUENTIAL, INCIDENTAL OR PUNITIVE DAMAGES WHATSOEVER, INCLUDING LOSS OF PROFITS, WHETHER ARISING DIRECTLY OR INDIRECTLY FROM ANY BREACH OF THE TERMS OR FROM ANY ACTIONS OR OMISSIONS OF ITS OFFICERS, EMPLOYEES OR AGENTS WHICH MAY GIVE RISE TO ANY LIABILITY (WHETHER IN TORT, INCLUDING FOR NEGLIGENCE, STRICT LIABILITY OR UNDER ANY OTHER THEORY OF LEGAL LIABILITY). IN NO EVENT SHALL THE AGGREGATE LIABILITY OF EITHER PARTY EXCEED THE AMOUNT OF THE FEE IN THE 3 MONTH PERIOD PRECEDING THE INCIDENT GIVING RISE TO THE CLAIM."), _c('br')])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('ol', {
    staticClass: "list-items",
    staticStyle: {
      "margin-left": "40px"
    },
    attrs: {
      "type": "a"
    }
  }, [_c('li', {
    staticStyle: {
      "padding-left": "10px"
    }
  }, [_vm._v(" All notices given hereunder shall be in writing and may be sent by registered mail, courier, email or facsimile transmission, and addressed to the receiving party at the address set out in the Invoice or as subsequently agreed between the parties. Notices shall be deemed to be given when received by the other party.")]), _vm._v(" "), _c('li', {
    staticStyle: {
      "padding-left": "10px"
    }
  }, [_vm._v(" The Agreement constitutes the entire understanding between the parties concerning its subject matter and supersedes all prior agreements and understandings between the parties. Automatad may update its standard terms and conditions on notice to Publisher.")]), _vm._v(" "), _c('li', {
    staticStyle: {
      "padding-left": "10px"
    }
  }, [_vm._v(" Nothing in the Agreement shall create any association, partnership, joint venture, employer-employee or agent-principal relationship between the parties.")]), _vm._v(" "), _c('li', {
    staticStyle: {
      "padding-left": "10px"
    }
  }, [_vm._v(" Any waiver or failure to perform or breach of any provision of the Agreement shall not operate or be construed as a waiver of any other right under the Agreement or of any other breach or failure whether of a similar nature or otherwise.")]), _vm._v(" "), _c('li', {
    staticStyle: {
      "padding-left": "10px"
    }
  }, [_vm._v(" If any provision of the Agreement is held to be invalid, the remaining provisions shall remain in full force and effect.")]), _vm._v(" "), _c('li', {
    staticStyle: {
      "padding-left": "10px"
    }
  }, [_vm._v(" Publisher acknowledges that Automatad may pay a referral fee in respect of this Agreement and Publisher hereby consents to Automatad releasing information related to the Fees to the applicable referrer in order to pay such referral fee.")]), _vm._v(" "), _c('li', {
    staticStyle: {
      "padding-left": "10px"
    }
  }, [_vm._v(" Neither party may assign the Agreement, by operation of law or otherwise, without the written consent of the other party, however either party may assign this agreement in its entirety without the other party’s consent to its affiliate or in connection with a merger, acquisition, corporate reorganization or a sale of all or substantially all of its assets.")]), _vm._v(" "), _c('li', {
    staticStyle: {
      "padding-left": "10px"
    }
  }, [_vm._v(" The Agreement and the rights of the parties hereunder shall be governed by and interpreted in accordance with the laws of the Delaware, US, without giving effect to principles of conflicts of laws. The parties hereto irrevocably and unconditionally submit to the exclusive jurisdiction of the courts of the Delaware, US, over any suit, action or proceeding arising out of or relating to the Agreement.")]), _vm._v(" "), _c('li', {
    staticStyle: {
      "padding-left": "10px"
    }
  }, [_vm._v(" If Publisher has entered into a prior agreement with Automatad, to the extent there are any inconsistencies between whether a particular.")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('div', [_c('div', {
    staticStyle: {
      "width": "40%",
      "display": "inline-block"
    }
  }, [_c('b', [_vm._v("[Publisher]")]), _c('br'), _c('br'), _vm._v(" "), _c('b', {
    staticStyle: {
      "margin-right": "10px"
    }
  }, [_vm._v("Signature")]), _vm._v(" "), _c('input', {
    staticStyle: {
      "background": "transparent",
      "border": "none",
      "border-bottom": "1px solid #000000"
    },
    attrs: {
      "type": "text"
    }
  }), _c('br'), _c('br'), _c('br'), _vm._v(" "), _c('b', {
    staticStyle: {
      "margin-right": "10px"
    }
  }, [_vm._v(" Name")]), _vm._v(" "), _c('input', {
    staticStyle: {
      "background": "transparent",
      "border": "none",
      "border-bottom": "1px solid #000000"
    },
    attrs: {
      "type": "text"
    }
  }), _c('br'), _c('br'), _c('br'), _vm._v(" "), _c('b', {
    staticStyle: {
      "margin-right": "10px"
    }
  }, [_vm._v(" Title")]), _c('input', {
    staticStyle: {
      "background": "transparent",
      "border": "none",
      "border-bottom": "1px solid #000000"
    },
    attrs: {
      "type": "text"
    }
  }), _c('br'), _c('br'), _c('br'), _vm._v(" "), _c('div', [_c('b', [_vm._v("Date Signed")]), _vm._v(" "), _c('div', {
    staticStyle: {
      "word-break": "break-all",
      "margin-left": "5px",
      "display": "inline-block",
      "vertical-align": "baseline",
      "width": "50%"
    },
    attrs: {
      "id": "pdt"
    }
  }, [_c('input', {
    staticStyle: {
      "background": "transparent",
      "border": "none",
      "border-bottom": "1px solid #000000"
    },
    attrs: {
      "type": "text"
    }
  })])])]), _vm._v(" "), _c('div', {
    staticStyle: {
      "width": "40%",
      "margin-left": "150px",
      "display": "inline-block"
    }
  }, [_c('br', {
    staticStyle: {
      "clear": "both"
    }
  }), _vm._v(" "), _c('b', [_vm._v("[Automatad]")]), _c('br'), _c('br'), _vm._v(" "), _c('b', {
    staticStyle: {
      "margin-right": "10px"
    }
  }, [_vm._v("Signature")]), _vm._v(" "), _c('input', {
    staticStyle: {
      "background": "transparent",
      "border": "none",
      "border-bottom": "1px solid #000000"
    },
    attrs: {
      "type": "text"
    }
  }), _c('br'), _c('br'), _c('br'), _vm._v(" "), _c('b', {
    staticStyle: {
      "margin-right": "10px"
    }
  }, [_vm._v("Name")]), _vm._v(" "), _c('input', {
    staticStyle: {
      "background": "transparent",
      "border": "none",
      "border-bottom": "1px solid #000000"
    },
    attrs: {
      "type": "text"
    }
  }), _c('br'), _c('br'), _c('br'), _vm._v(" "), _c('b', {
    staticStyle: {
      "margin-right": "10px"
    }
  }, [_vm._v("Title")]), _vm._v(" "), _c('input', {
    staticStyle: {
      "background": "transparent",
      "border": "none",
      "border-bottom": "1px solid #000000"
    },
    attrs: {
      "type": "text"
    }
  }), _c('br'), _c('br'), _c('br'), _vm._v(" "), _c('div', [_c('b', [_vm._v("Date Signed")]), _vm._v(" "), _c('div', {
    staticStyle: {
      "word-break": "break-all",
      "margin-left": "5px",
      "display": "inline-block",
      "vertical-align": "baseline",
      "width": "50%"
    },
    attrs: {
      "id": "pdt2"
    }
  }, [_c('input', {
    staticStyle: {
      "background": "transparent",
      "border": "none",
      "border-bottom": "1px solid #000000"
    },
    attrs: {
      "type": "text"
    }
  })])])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-3ccfd4dc!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/modules/admin/Agreement.vue
// module id = 678
// module chunks = 2